import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdjustQuestionScoreModel, IExam, MarkingQuestionModel, SaqCandidateQuestionModel } from 'src/app/interface/dto';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { ScoreAdjustmentModalComponent } from '../../Shared/score-adjustment-modal/score-adjustment-modal.component';
import { ExamOperationService } from '../exam-operation.service';
import { ConfirmComponent } from 'src/app/shared-layout/confirm/confirm.component';
import { el, tr } from 'date-fns/locale';
declare var $: any
@Component({
  selector: 'app-mark-saq',
  templateUrl: './mark-saq.component.html',
  styleUrls: ['./mark-saq.component.scss']
})
export class MarkSaqComponent implements OnInit {
  mode: string = 'mark';
  candidatesQuestionsData: SaqCandidateQuestionModel[] = [];
  examination: IExam;
  selectedCandidateQuestion: SaqCandidateQuestionModel = null;
  adjustmentData = {
    score: 0,
    reason: ''
  };

  constructor(private snackBar: SnackbarService,
    private examService: ExamService,
    private examSchService: ExamScheduleService,
    private route: ActivatedRoute,
    private modalService: NgbModal) { }

  async ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.mode = params['mode'] || 'mark';
    });

    let selectedExamID = this.examService.selectedExamIds[0];
    this.examination = this.examService.selectedExams[0];
    let selectedSchID = (this.examSchService.selectedIds && this.examSchService.selectedIds[0]) ?? 0;
    //console.log("SELECTED SCHEDULE:", selectedSchID);
    let data = { ExaminationScheduleID: selectedSchID, ExaminationID: selectedExamID, Mode: this.mode };
    this.candidatesQuestionsData = await this.examService.getMarkSAQQuestions(data) as any[];
  }

  calculateTotalScore(candidate: SaqCandidateQuestionModel) {
    return candidate.essayQuestionModels.reduce((acc, q) => acc + q.essayMarkEarned, 0);
  }
  async markCorrect(_t15: MarkingQuestionModel, index: number, examNo: string) {
    let candIndex = this.candidatesQuestionsData.findIndex(c => c.examNo == examNo);
    if (this.candidatesQuestionsData[candIndex].essayQuestionModels[index].answerStatusString == 'Correct') {
      return;//no need to mark correct since it's already correct
    }
    this.candidatesQuestionsData[candIndex].essayQuestionModels[index].essayMarkEarned = _t15.mark;
    _t15.answerStatusString = "Correct";
    _t15.answerStatusValue = "Correct";

    this.candidatesQuestionsData[candIndex].essayQuestionModels[index].answerStatusString = _t15.answerStatusString
    await this.examService.markSAQQuestion(_t15);

  }
  async markIncorrect(_t15: MarkingQuestionModel, index: number, examNo: string) {
    let candIndex = this.candidatesQuestionsData.findIndex(c => c.examNo == examNo);
    if (this.candidatesQuestionsData[candIndex].essayQuestionModels[index].answerStatusString == 'Incorrect') {
      return;
    }
    _t15.answerStatusString = "Incorrect";
    _t15.answerStatusValue = "Incorrect";
    this.candidatesQuestionsData[candIndex].essayQuestionModels[index].essayMarkEarned = 0;
    this.candidatesQuestionsData[candIndex].essayQuestionModels[index].answerStatusString = _t15.answerStatusString;
    await this.examService.markSAQQuestion(_t15);
  }
  get totalMarkedCandidates() {
    return this.candidatesQuestionsData.filter(cand => cand.marked).length
  }
  get totalUnMarkedCandidates() {
    return this.candidatesQuestionsData.filter(cand => !cand.marked).length
  }
  get totalCandidatesReviewed() {
    return this.candidatesQuestionsData.filter(cand => cand.reviewed).length
  }
  get totalCandidatesPending() {
    return this.candidatesQuestionsData.filter(cand => !cand.reviewed).length
  }
  openAdjustScoreModal(_t15: MarkingQuestionModel, index: number, examNo: string) {
    const modalRef = this.modalService.open(ScoreAdjustmentModalComponent, { centered: true });

    modalRef.componentInstance.currentScore = _t15.essayMarkEarned;
    modalRef.componentInstance.maxScore = _t15.mark;
    modalRef.componentInstance.questionId = _t15.esqId;
    modalRef.componentInstance.questionNo = _t15.questionNo;
    modalRef.componentInstance.examinationType = 'SAQ';
    modalRef.componentInstance.answerStatusString = _t15.answerStatusString;

    modalRef.result.then((result: AdjustQuestionScoreModel) => {
      if (result) {
        // if (result.adjustedScore === _t15.essayMarkEarned && _t15.answerStatusString != 'NotMarked') {
        //   this.snackBar.warning('No adjustment applied since the current score matches the adjusted score.');
        //   return;
        // }
        this.adjustScore(result, _t15, index, examNo);
      }
    }, (reason) => {
      // Modal dismissed
    });
  }

  async adjustScore(adjustmentData: AdjustQuestionScoreModel, _t15: MarkingQuestionModel, index: number, examNo: string) {
    try {
      await this.examService.adjustQuestionScore(adjustmentData);

      const candIndex = this.candidatesQuestionsData.findIndex(c => c.examNo == examNo)
      this.candidatesQuestionsData[candIndex].essayQuestionModels[index].essayMarkEarned = adjustmentData.adjustedScore;
      this.candidatesQuestionsData[candIndex].reviewed = false;
      const answerStatus = adjustmentData.adjustedScore === _t15.mark ? "Correct" : "Incorrect";
      _t15.answerStatusString = answerStatus;
      _t15.answerStatusValue = answerStatus;

      this.snackBar.success('Score adjusted successfully');
    } catch (error) {
      this.snackBar.error('Failed to adjust score');
    }
  }

  loadCandidateQuestions(data: SaqCandidateQuestionModel) {
    this.selectedCandidateQuestion = data;
    const buttons = document.querySelectorAll('.canlist');
    buttons.forEach(button => {
      button.classList.remove('active');
    });
    const activeButton = document.getElementById(data.examNo.toString());
    if (activeButton) {
      activeButton.classList.add('active');
    }
    const topElement = document.getElementById(`scrollToTop`);
    if (topElement) {
      topElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  hasNextCandidate() {
    if (!this.candidatesQuestionsData || this.candidatesQuestionsData.length === 0) {
      return false;
    }
    const currentIndex = this.candidatesQuestionsData.findIndex(q => q.examNo === this.selectedCandidateQuestion.examNo);
    return currentIndex < this.candidatesQuestionsData.length - 1;
  }
  hasPreviousCandidate() {
    if (!this.candidatesQuestionsData || this.candidatesQuestionsData.length === 0) {
      return false;
    }
    const currentIndex = this.candidatesQuestionsData.findIndex(q => q.examNo === this.selectedCandidateQuestion.examNo);
    return currentIndex > 0;
  }

  nextCandidate() {
    const currentIndex = this.candidatesQuestionsData.findIndex(q => q.examNo === this.selectedCandidateQuestion.examNo);
    if (currentIndex < this.candidatesQuestionsData.length - 1) {
      this.loadCandidateQuestions(this.candidatesQuestionsData[currentIndex + 1]);
    }
  }
  previousCandidate() {
    const currentIndex = this.candidatesQuestionsData.findIndex(q => q.examNo === this.selectedCandidateQuestion.examNo);
    if (currentIndex > 0) {
      this.loadCandidateQuestions(this.candidatesQuestionsData[currentIndex - 1]);
    }
  }
  markCandidate(origin: any) {
    if (this.selectedCandidateQuestion.essayQuestionModels.find(x => x.answerStatusString == 'NotMarked')) {
      this.snackBar.error("Please mark all questions before submitting the assessment");
      return;
    }
    $('#confirmSubmitModal').modal({
      backdrop: false,
      keyboard: true //allows escape key to close
    });
    $('#confirmSubmitModal').modal('show');

  }
  closeModal() {
    $('#confirmSubmitModal').modal('hide');
  }
  confirmSubmit() {
    try {
      let data = { ExaminationScheduleID: this.selectedCandidateQuestion.examinationScheduleID, ExaminationID: this.examination.id, Attempt: this.selectedCandidateQuestion.attempt, Mode: this.mode };
      this.examService.submitSaqCandidate(data).then((r: any) => {
        if (this.mode == 'mark') {
          this.snackBar.success("Assessment Marked")
        } else {
          this.snackBar.success("Assessment Reviewed")
        }
        let candIndex = this.candidatesQuestionsData.findIndex(c => c.examNo == this.selectedCandidateQuestion.examNo);
        this.candidatesQuestionsData[candIndex].marked = true;
        this.candidatesQuestionsData[candIndex].reviewed = this.mode == 'review' ? true : false;

      });
    } catch (error) {
      this.snackBar.error("An error occured when submitting")
      console.log(error);
    } finally {
      this.closeModal();
    }
  }

}
